module.exports = __webpack_public_path__ + "static/media/boletoAlt.57494f80.svg";